<div class="col-12 px-0">
    <p class="page-header">Table below shows list of all Approved Payers</p>
</div>
<form [formGroup]="searchPayer" (ngSubmit)="getPayers()">
  <div class="row">
    <div class="col-8 col-md-3 form-group">
      <mat-form-field>
        <input matInput placeholder="Search" formControlName="searchText">
      </mat-form-field>
    </div>
    <div class="col-4 col-md-2 form-group">
      <button type="submit" class="btn btn-lg btn-block btn-greengo" npFocusOutClicked>Search</button>
    </div>
    <div class="col-6 col-md-2 form-group">
       <button type="button" class="btn btn-lg btn-block btn-greengo" (click)="addNewApprovedPayer()">Add new Payer</button>
    </div>
  </div>
</form>
<ng-container *ngIf="!isLoading">
  <ng-table-pagination
    [rows]="rows"
    [columns]="columns"
    [totalItems]="totalItems"
    [showCheckAll]="false"
    [checkItemEvent]="true"
    (tableChanged)="getPayers($event)"
    [showCheckbox]="true"
    [multipleSelectedRow]="false">
  </ng-table-pagination>
</ng-container>